import { BaseModel } from "sjs-base-model";

export default class MessaggioEsitoModel extends BaseModel {
    public readonly codice: number = 0;
    public readonly descrizione: string = "";
    public readonly tipoMessaggio: number = 0;

    constructor(data: Partial<MessaggioEsitoModel>) {
        super();

        this.update(data);
    }
}
